import { render } from "./ClinicalHistoryDetail.vue?vue&type=template&id=bb48b0de&scoped=true"
import script from "./ClinicalHistoryDetail.vue?vue&type=script&lang=js"
export * from "./ClinicalHistoryDetail.vue?vue&type=script&lang=js"

import "./ClinicalHistoryDetail.vue?vue&type=style&index=0&id=bb48b0de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb48b0de"]])

export default __exports__